export default {
  turmas: [],
  turma: {}
}
